import React, { createContext, useContext, useState, useEffect } from "react";
import socket from "../services/socket";
import { useAuth } from "./AuthContext";
import { useSwal } from "../services/SweetAlert";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { authUser } = useAuth();
  const { notify } = useSwal();

  const [socketFlag, setSocketFlag] = useState(null);
  const [incomingCall, setIncomingCall] = useState({});
  const [callData, setCallData] = useState(null);
  const [fetchNotification, setFetchNotification] = useState(0);

  // 👉 Connect & register agent whenever authUser changes
  useEffect(() => {
    if (authUser?.Extensions_Number) {
      if (!socket.connected) socket.connect();

      socket.emit("registerAgent", authUser.Extensions_Number, (res) => {
        if (res.success) {
          console.log("✅ Agent registered:", authUser.Extensions_Number);
        } else {
          console.error("❌ Registration failed:", res.error);
        }
      });
    }

    return () => {
      socket.disconnect();
    };
  }, [authUser]);

  // 👉 Global socket listeners
  useEffect(() => {
    if (!socket) return;

    // Incoming call
    socket.on("incoming_call", (data) => {
      console.log("📞 Incoming call :: ", data);
      setIncomingCall(data);
      setCallData(data);
    });

    // Call hang-up
    socket.on("call_hangedup", () => {
      console.log("📴 Call hanged up");
      setCallData(null);
      setIncomingCall({});
    });

    // Tickets
    socket.on("ticket:created", (data) => {
      // if (Number(data?.details?.User) !== Number(authUser?.Code)) {
      //   notify("You have a new ticket!");
        setFetchNotification((prev) => prev + 1);
      // }
    });

    socket.on("ticket:Create", (data) => {
      // if (Number(data?.details?.User) !== Number(authUser?.Code)) {
        // notify("You have a new ticket!");
        setFetchNotification((prev) => prev + 1);
      // }
    });

    // Cleanup
    return () => {
      socket.off("incoming_call");
      socket.off("call_hangedup");
      socket.off("ticket:created");
      socket.off("ticket:Create");
      setSocketFlag("");
    };
  }, [socket, authUser]);

  return (
    <SocketContext.Provider
      value={{
        socket,
        socketFlag,
        setSocketFlag,
        incomingCall,
        setIncomingCall,
        callData,
        setCallData,
        fetchNotification,
        setFetchNotification,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
